import React from "react";
import MultiSelect from "react-select";

export default function MultiSelectReduxForm(field) {
  const {
    meta,
    className,
    input: { value, onBlur, onChange },
    options,
  } = field;

  const handleChange = (array) => {
    onChange(array.map((val) => val));
  };

  return (
    <MultiSelect
      aria-label={field["aria-label"]}
      className={className}
      isMulti={true}
      value={value}
      onChange={(val) => handleChange(val)}
      onBlur={(event) => event.preventDefault()}
      options={options}
    />
  );
}
